import * as React from 'react';

import { BaseExercisePage } from '../baseExercisePage';
import { Flexibility } from './flexibility';
import * as Edge from '../../../core';

import FlexibilityResults from './results';
import FlexibilityConfigForm from './configForm';

export default class FlexibilityPage extends BaseExercisePage<
	Edge.Models.FlexibilityExerciseConfiguration,
	Edge.Models.FlexibilityExerciseResult
> {
	protected renderConfiguration(): JSX.Element {
		const { lockConfiguration, operationName, mode } = this.props;
		const { configuration } = this.state;

		return (
			<FlexibilityConfigForm
				mode={mode}
				operationName={operationName}
				onSubmit={this.startExercise}
				initialConfiguration={configuration}
				lockConfiguration={lockConfiguration}
			/>
		);
	}
	protected renderExercise(): JSX.Element {
		const { currentProfile, mode } = this.props;
		const { configuration, fullScreen } = this.state;

		return (
			<Flexibility
				mode={mode}
				debugMode={this.props.debugMode}
				renderScale={currentProfile.renderScale}
				touchControls={currentProfile.touchControls}
				completeExercise={this.finishExercise}
				abortingExercise={this.abortingExercise}
				fullScreen={fullScreen!}
				configuration={configuration}
			/>
		);
	}
	protected renderResults(): JSX.Element {
		const { hideExerciseResults } = this.props;

		return (
			<FlexibilityResults
				results={this.state.result!}
				complete={this.complete}
				retry={this.retryExercise}
				completeText={this.props.completeText}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
